"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      .gatsby-image-outer-wrapper,\n      .gatsby-image-wrapper {\n        height: 100%;\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GatsbyImageContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _core = require("./core");

var GatsbyImageContainer = function GatsbyImageContainer(props) {
  return _react.default.createElement(_StyledBox, props);
};

exports.GatsbyImageContainer = GatsbyImageContainer;

var _StyledBox = (0, _styledComponents.default)(_core.Box)(_templateObject());